
import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { DocumentType } from 'Api/CoreApi';

@Component({
    template: "#download-pdf-button-template"
})
export class DownloadPdfButtonComponent extends ABaseComponent {
    @Prop()
    linkId: string;
    @Prop()
    documentType: DocumentType;
    @Prop({ default: '' })
    orderEmail: string;
    showModal: boolean = false;
    async downloadPdf() {
        try {
            if (!this.orderEmail) {
                this.showModal = true;
                return;
            }
            window.location.href = "/api/CustomerCenter/DownloadPdf?documentType=" + this.documentType + "&linkId=" + this.linkId + "&orderEmail=";
        } catch (e) {
            this.setError(e);
        }
    }
}

Vue.component('download-pdf-button', DownloadPdfButtonComponent);
